enum Actions {
  ADD_NOTE = "addNote",
  ADD_TO_ROUTE = "addToRoute",
  ADD_ACTIVITY = "addActivity",
  MANAGE_RELATIONSHIP = "manageRelationship",
  MANAGE_CHILD_COMPANIES = "manageChildCompanies",
  MANAGE_PARENT_COMPANY = "manageParentCompany",
  MANAGE_COMPANIES = "manageCompanies",
  MANAGE_PERSONS = "managePersons",
  MANAGE_PERSON = "managePerson",
  ADD_DEAL = "addDeal",
  EDIT_STAGE = "editStage",
  MANAGE_GROUPS = "manageGroups",
  MARK_WON = "markWon",
  MARK_LOSS = "markLoss",
  MANAGE_FREQUENCIES = "manageFrequencies",
  EDIT_ENTITY = "editEntity",
  EMAIL = "email",
  EMAIL_SUBSCRIBE = "emailSubscribe",
  EMAIL_UNSUBSCRIBE = "emailUnsubscribe",
  CALL = "call",
  VISIT_SITE = "visitSite",
  GET_DIRECTIONS = "getDirections",
  OPEN_PERSON = "openPerson",
  OPEN_COMPANY = "openCompany",
  STREET_VIEW = "streetView",
}

export default Actions;
